const root = "AlphabetNav-module_root_Np8Ir1YQ";
const heading = "AlphabetNav-module_heading_F5II3056";
const list = "AlphabetNav-module_list_3RrTHOgs";
const link = "AlphabetNav-module_link_oqEGGfHB";
const styles = {
  root,
  heading,
  list,
  link
};
export {
  styles as default,
  heading,
  link,
  list,
  root
};
